export default {
  props: {
    folderInfo: Object,
  },
  data() {
    return {
      id: this.$options.name,
    };
  },
  methods: {
    handleGoToFolder(e) {
      if (this.folderInfo) {
        this.$store.state.isUploadingMobile = true;

        this.$router.push(
          `/${this.$store.state.company}/${
            this.folderInfo.myspace ? "myspace" : "home"
          }/expanded/${this.folderInfo.id}`
        );
      }
    },
  },
};
